import Radio, { RadioGroup } from "@8x8/oxygen-radio";

import { PositionedLabel } from "@/react/features/styled/PositionedLabel";
import { DynamicWidthContainer } from "@/react/features/styled/WidthContainers";

const LabeledRadioGroup = (props) => {
  const { prompt, options, renderRadioButton, ...other } = props;
  return (
    <DynamicWidthContainer>
      {prompt && <PositionedLabel>{prompt}</PositionedLabel>}
      <RadioGroup {...other}>
        {options.map((option) =>
          renderRadioButton ? (
            renderRadioButton(option)
          ) : (
            <Radio key={option} name={option} value={option} label={option} />
          )
        )}
      </RadioGroup>
    </DynamicWidthContainer>
  );
};

export default LabeledRadioGroup;
